import secureLocalStorage from "react-secure-storage";
import * as StorageConstants from "../Models/SecureStorageConstants";

export type StoredSessionUser = {
    uuid?: string;
    name?: string;
    username?: string;
    email?: string;
    firstName?: string;
    /** Sign-in payload (`SecurityUserResponse`). */
    surname?: string;
    /** Older session payloads spell the same field this way. */
    surName?: string;
    /** Present on JWT/sign-in payload (flat). */
    customerUuid?: string;
    /** Present on retrieveMe / richer session payloads (nested). */
    customer?: { uuid?: string; name?: string };
};

/** Home customer of the logged-in user — supports both flat and nested session shapes. */
export const getStoredUserCustomerUuid = (): string | undefined => {
    const user = getStoredUser();
    const nested = user?.customer?.uuid?.trim();
    if (nested) {
        return nested;
    }
    const flat = user?.customerUuid?.trim();
    return flat || undefined;
};

export const getStoredPermissions = (): string[] => {
    const stored = secureLocalStorage.getItem(StorageConstants.PERMISSIONS);
    if (stored == null) {
        return [];
    }
    try {
        const parsed = typeof stored === "string" ? JSON.parse(stored) : stored;
        return Array.isArray(parsed) ? (parsed as string[]) : [];
    } catch {
        return [];
    }
};

export const getStoredUser = (): StoredSessionUser | null => {
    const stored = secureLocalStorage.getItem(StorageConstants.USER);
    if (stored == null) {
        return null;
    }
    try {
        return (typeof stored === "string" ? JSON.parse(stored) : stored) as StoredSessionUser;
    } catch {
        return null;
    }
};

export const getStoredAccessToken = (): string | null => {
    const token = secureLocalStorage.getItem(StorageConstants.ACCESS_TOKEN);
    return token == null ? null : String(token);
};

export const getStoredRefreshToken = (): string | null => {
    const token = secureLocalStorage.getItem(StorageConstants.REFRESH_TOKEN);
    return token == null ? null : String(token);
};

export const setStoredTokens = (accessToken: string, refreshToken: string): void => {
    secureLocalStorage.setItem(StorageConstants.ACCESS_TOKEN, accessToken);
    secureLocalStorage.setItem(StorageConstants.REFRESH_TOKEN, refreshToken);
};

export const storedSessionHasPermission = (permissions: string[], permission: string): boolean =>
	permissions.some((p) => p === permission);
